export const TimerTypes = {
    TOGGLE_TIMER : 'TOGGLE_TIMER_TIMERS',
    UPDATE_TIMERS : 'UPDATE_TIMERS_TIMERS',
    MARKCHANGED_TIMERS : 'MARKCHANGED_TIMERS_TIMERS',
    RESET : 'RESET',
};